export const apis = {

    // apis
    saime: '/api/saime',
    catalogues: '/api/catalogues',
    geographicalEntities: '/api/geographical-entities',

    // invokes
    adminExists: '/users/exists/',

    // auth
    login: '/applicant/login/',
    passwordEmail: '/applicant/password/email/',
    passwordReset: '/applicant/password/reset/',
    refresh: '/applicant/refresh/',
    logout: '/logout/',

    // profile
    hasAccess: '/profile/has-access/',
    changePassword: '/users/change-password',

    // applicants
    applicant: '/applicant/',
    applicantCollection: '/applicant-collection/',

    // Consular Data
    basicData: '/basic-data/',
    migrationData: '/migration-data/',
    contactInformation: '/contact-information/',
    familyGroup: '/family-group/',

    // Additional procedure data
    witnessPerson: '/witness-person/',

    // Proxy
    editProxy: '/applicant/proxy/',

    // Agendar cita
    scheduleAppointment: '/applicant/schedule-appointment',

    dayCalendar: '/api/days-calendar',

    otherPerson: '/other-person',

    requestManagement: '/request-management/',

    slae: '/api/slae/verification',
    reasonProcedure: '/procedure/reasons-parent',
    procedures: '/procedures/',

    // Reports
    reports: '/reports',
};
